"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6535],{

/***/ 31298:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(36690);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(93089);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(59106);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(61250);
/* harmony import */ var _mui_icons_material_Edit__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(68870);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(29901);
/* harmony import */ var _components_buttons_mutation_button__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(56487);







var EditButton = function(props) {
    var item = props.item, t = props.t, onEdit = props.onEdit, id = props.id, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(props, [
        "item",
        "t",
        "onEdit",
        "id"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_buttons_mutation_button__WEBPACK_IMPORTED_MODULE_3__/* .MutationIconButton */ .t, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
        id: id,
        tooltipMsg: t([
            "shared:edit"
        ], {
            defaultValue: "Edit"
        }),
        onClick: function() {
            return onEdit(item);
        }
    }, rest), {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_icons_material_Edit__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {})
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (EditButton);


/***/ }),

/***/ 56535:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$d": function() { return /* binding */ DurationFormatter; },
/* harmony export */   "CN": function() { return /* binding */ AheadBehindTypeProvider; },
/* harmony export */   "DG": function() { return /* binding */ ActionsProvider; },
/* harmony export */   "DX": function() { return /* binding */ TimestampFormatter; },
/* harmony export */   "Ix": function() { return /* binding */ TimestampTypeProvider; },
/* harmony export */   "RE": function() { return /* binding */ RoleTypeProvider; },
/* harmony export */   "Tb": function() { return /* binding */ formatAlarmType; },
/* harmony export */   "Wi": function() { return /* binding */ StopsCauseTypeProvider; },
/* harmony export */   "Y9": function() { return /* binding */ reshapeFormat; },
/* harmony export */   "iN": function() { return /* binding */ formatAlarmTypeInterpolated; },
/* harmony export */   "mL": function() { return /* binding */ DurationTypeProvider; },
/* harmony export */   "uE": function() { return /* binding */ DateFormatter; },
/* harmony export */   "wR": function() { return /* binding */ StopsCauseTypeFormatter; },
/* harmony export */   "wY": function() { return /* binding */ EditButtonProvider; },
/* harmony export */   "y0": function() { return /* binding */ AlarmTypeTypeProvider; }
/* harmony export */ });
/* unused harmony exports StartCaseProvider, AlarmTypeFormatter */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(36690);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(61250);
/* harmony import */ var _devexpress_dx_react_grid__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(70748);
/* harmony import */ var _mui_icons_material_FileCopy__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(12163);
/* harmony import */ var _mui_icons_material_Warning__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(45404);
/* harmony import */ var _mui_material_Chip__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(84074);
/* harmony import */ var _mui_material_Tooltip__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(60945);
/* harmony import */ var _mui_material_Typography__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(1827);
/* harmony import */ var _mui_material_colors__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(51848);
/* harmony import */ var _mui_material_colors__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(88665);
/* harmony import */ var generated_graphql_schema__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(89178);
/* harmony import */ var lodash_startCase__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(59659);
/* harmony import */ var lodash_startCase__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(lodash_startCase__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(29901);
/* harmony import */ var _components_buttons_edit_button__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(31298);
/* harmony import */ var _helpers_format_target__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(45955);
/* harmony import */ var _helpers_helper_functions__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(94227);
/* harmony import */ var _lib_stop_type_names__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(99591);
/* harmony import */ var _types_types__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(97887);
/* harmony import */ var _buttons__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(56487);


















var TimestampTypeProvider = function(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_devexpress_dx_react_grid__WEBPACK_IMPORTED_MODULE_1__/* .DataTypeProvider */ .zl, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        formatterComponent: TimestampFormatter(props.format)
    }, props));
};
var TimestampFormatter = function(format) {
    return function(param) {
        var value = param.value;
        var timestamp = Date.parse(value);
        if (isNaN(timestamp) === false) {
            return (0,_helpers_helper_functions__WEBPACK_IMPORTED_MODULE_5__/* .timeFormatyyyyMMdhmmss */ .zs)(new Date(value), format === null || format === void 0 ? void 0 : format.locale);
        } else {
            return value;
        }
    };
};
var reshapeFormat = function(param) {
    var locale = param.locale, options = param.options;
    switch(locale){
        case "da":
            {
                return {
                    locale: "en-GB",
                    options: options
                };
            }
        case "de":
            {
                return {
                    locale: "de-DE",
                    options: options
                };
            }
        case "fr":
            {
                return {
                    locale: "fr-FR",
                    options: options
                };
            }
        default:
            {
                return {
                    locale: locale,
                    options: options
                };
            }
    }
};
var DateFormatter = function(date, i18nLocal, i18nOptions) {
    var ref = reshapeFormat({
        locale: i18nLocal,
        options: i18nOptions
    }), locale = ref.locale, options = ref.options;
    return date.toLocaleString(locale, options);
};
/**
 * User status formatting.
 */ var StartCaseFormatter = function(param) {
    var row = param.row, value = param.value;
    var output = row.enabled ? startCase(value) : "DISABLED / ".concat(startCase(value));
    return /*#__PURE__*/ _jsx("span", {
        children: output
    });
};
var StartCaseProvider = function(props) {
    return /*#__PURE__*/ _jsx(DataTypeProvider, _object_spread({
        formatterComponent: StartCaseFormatter
    }, props));
};
/**
 * Stop cause formatting.
 */ var StopsCauseTypeFormatter = function(t, theme, defaultValue) {
    return function(param) {
        var value = param.value, row = param.row;
        if ((!value || value === "") && defaultValue) {
            value = defaultValue;
        }
        var colorLookup = value;
        if (!(0,_lib_stop_type_names__WEBPACK_IMPORTED_MODULE_6__/* .stopTypeNames */ .R)(t)[value] && row.type) {
            colorLookup = row.type;
        } else if ((0,_lib_stop_type_names__WEBPACK_IMPORTED_MODULE_6__/* .stopTypeNames */ .R)(t)[value]) {
            value = (0,_lib_stop_type_names__WEBPACK_IMPORTED_MODULE_6__/* .stopTypeNames */ .R)(t)[value];
        }
        var backgroundColor = theme.blackbird.stops.UNREGISTERED.color.main;
        if (colorLookup in theme.blackbird.stops) {
            backgroundColor = theme.blackbird.stops[colorLookup].color.main;
        }
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_Chip__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
            label: value,
            style: {
                backgroundColor: backgroundColor
            }
        });
    };
};
var StopsCauseTypeProvider = function(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_devexpress_dx_react_grid__WEBPACK_IMPORTED_MODULE_1__/* .DataTypeProvider */ .zl, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        formatterComponent: StopsCauseTypeFormatter(props.t, props.theme, props.defaultValue)
    }, props));
};
/**
 * Role chip formatting.
 */ var RoleTypeFormatter = function(param) {
    var value = param.value;
    if (value) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
            children: [
                value.name,
                " ",
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_Chip__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                    style: {
                        fontSize: "9px",
                        height: "22px"
                    },
                    color: "primary",
                    variant: "outlined",
                    label: value.type
                })
            ]
        });
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {});
};
var RoleTypeProvider = function(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_devexpress_dx_react_grid__WEBPACK_IMPORTED_MODULE_1__/* .DataTypeProvider */ .zl, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        formatterComponent: RoleTypeFormatter
    }, props));
};
/**
 * Duration formatting.
 */ var DurationFormatter = function(param) {
    var utils = param.utils, t = param.t, _exactTime = param.exactTime, exactTime = _exactTime === void 0 ? false : _exactTime, _warnWhenNegative = param.warnWhenNegative, warnWhenNegative = _warnWhenNegative === void 0 ? false : _warnWhenNegative, _variant = param.variant, variant = _variant === void 0 ? "body2" : _variant, _skipJsx = param.skipJsx, skipJsx = _skipJsx === void 0 ? false : _skipJsx;
    return function(param) {
        var value = param.value, _strict = param.strict, strict = _strict === void 0 ? false : _strict;
        var textValue;
        if (value === 0) {
            // FIXME: Needs translation.
            textValue = t([
                "shared:0Seconds"
            ], {
                defaultValue: "0 seconds"
            });
        } else {
            if (typeof value === "number") {
                if (strict) {
                    textValue = utils.formatDistanceStrict(0, value);
                } else {
                    textValue = utils.formatDistance(0, value, {
                        includeSeconds: true
                    });
                }
                if (value < 0) {
                    textValue = t([
                        "shared:nTimeGained"
                    ], {
                        defaultValue: "{{time}} gained",
                        time: textValue
                    });
                }
            } else {
                textValue = value;
            }
        }
        // Note: Format this way, instead of using date-fns, because date-fns format is timezone aware,
        // resulting in format(0, 'HH:mm:ss') = '01:00:00' for GMT+1.
        var toHHMMSS = function(v) {
            var secNum = Math.abs(Math.floor(v / 1000));
            var hours = Math.floor(secNum / 3600);
            var minutes = Math.floor((secNum - hours * 3600) / 60);
            var seconds = secNum - hours * 3600 - minutes * 60;
            hours = hours === 0 || isNaN(hours) ? "" : "".concat(hours) + t([
                "shared:abbrHour"
            ], {
                defaultValue: "h"
            });
            minutes = minutes === 0 || isNaN(minutes) ? "" : "".concat(minutes) + t([
                "shared:abbrMinutes"
            ], {
                defaultValue: "min"
            });
            seconds = seconds === 0 || isNaN(seconds) ? "" : "".concat(seconds) + t([
                "shared:abbrSeconds"
            ], {
                defaultValue: "sec"
            });
            var fs = v === 0 ? t([
                "shared:nothing"
            ], {
                defaultValue: "Nothing"
            }) : hours + " " + minutes + " " + seconds;
            return v < 0 ? "-".concat(fs) : "".concat(fs);
        };
        if (skipJsx) {
            return exactTime ? toHHMMSS(value) : textValue;
        }
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            style: {
                display: "inline-block"
            },
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_Tooltip__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                title: exactTime ? textValue : toHHMMSS(value),
                placement: "top",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material_Typography__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                    variant: variant,
                    children: [
                        exactTime ? toHHMMSS(value) : textValue,
                        " ",
                        warnWhenNegative && value < 0 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_icons_material_Warning__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                            color: "secondary",
                            style: {
                                marginLeft: "8px",
                                fontSize: "20px",
                                marginBottom: "-4px"
                            }
                        }) : null
                    ]
                })
            })
        });
    };
};
var AheadBehindTypeProvider = function(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_devexpress_dx_react_grid__WEBPACK_IMPORTED_MODULE_1__/* .DataTypeProvider */ .zl, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        formatterComponent: function(param) {
            var value = param.value;
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                style: {
                    color: value === 0 ? undefined : value > 0 ? _mui_material_colors__WEBPACK_IMPORTED_MODULE_11__/* ["default"][500] */ .Z[500] : _mui_material_colors__WEBPACK_IMPORTED_MODULE_12__/* ["default"][500] */ .Z[500]
                },
                children: (0,_helpers_format_target__WEBPACK_IMPORTED_MODULE_13__/* .formatTargetPerformanceDirect */ .t)(props.t, value)
            });
        }
    }, props));
};
var DurationTypeProvider = function(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_devexpress_dx_react_grid__WEBPACK_IMPORTED_MODULE_1__/* .DataTypeProvider */ .zl, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        formatterComponent: DurationFormatter({
            utils: props.utils,
            t: props.t,
            exactTime: true,
            warnWhenNegative: props.warnWhenNegative
        })
    }, props));
};
/**
 * Alarm type formatting.
 */ var AlarmTypeTypeProvider = function(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_devexpress_dx_react_grid__WEBPACK_IMPORTED_MODULE_1__/* .DataTypeProvider */ .zl, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        formatterComponent: AlarmTypeFormatter(props.t)
    }, props));
};
var AlarmTypeFormatter = function(t) {
    return function(param) {
        var value = param.value;
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
            children: formatAlarmType(t, value)
        });
    };
};
var formatAlarmType = function(t, type) {
    switch(type){
        case generated_graphql_schema__WEBPACK_IMPORTED_MODULE_14__/* .AlarmType.AboveX */ .$C.AboveX:
            return t([
                "alarms:AboveX"
            ], {
                defaultValue: "value > x"
            });
        case generated_graphql_schema__WEBPACK_IMPORTED_MODULE_14__/* .AlarmType.BelowX */ .$C.BelowX:
            return t([
                "alarms:BelowX"
            ], {
                defaultValue: "value < x"
            });
        case generated_graphql_schema__WEBPACK_IMPORTED_MODULE_14__/* .AlarmType.AboveXForTSeconds */ .$C.AboveXForTSeconds:
            return t([
                "alarms:AboveXForTSeconds"
            ], {
                defaultValue: "value > x for t seconds"
            });
        case generated_graphql_schema__WEBPACK_IMPORTED_MODULE_14__/* .AlarmType.BelowXForTSeconds */ .$C.BelowXForTSeconds:
            return t([
                "alarms:BelowXForTSeconds"
            ], {
                defaultValue: "value < x for t seconds"
            });
        case generated_graphql_schema__WEBPACK_IMPORTED_MODULE_14__/* .AlarmType.AboveXForTSecondsWithinYTimeNTimes */ .$C.AboveXForTSecondsWithinYTimeNTimes:
            return t([
                "alarms:AboveXForTSecondsWithinYTimeNTimes"
            ], {
                defaultValue: "value > x for t seconds, n times, within y seconds"
            });
        case generated_graphql_schema__WEBPACK_IMPORTED_MODULE_14__/* .AlarmType.BelowXForTSecondsWithinYTimeNTimes */ .$C.BelowXForTSecondsWithinYTimeNTimes:
            return t([
                "alarms:BelowXForTSecondsWithinYTimeNTimes"
            ], {
                defaultValue: "value < x for t seconds, n times, within y seconds"
            });
        case generated_graphql_schema__WEBPACK_IMPORTED_MODULE_14__/* .AlarmType.SumOfTAboveXWithinYTime */ .$C.SumOfTAboveXWithinYTime:
            return t([
                "alarms:SumOfTAboveXWithinYTime"
            ], {
                defaultValue: "SUM(time value > x) > t seconds, within y seconds"
            });
        case generated_graphql_schema__WEBPACK_IMPORTED_MODULE_14__/* .AlarmType.SumOfTBelowXWithinYTime */ .$C.SumOfTBelowXWithinYTime:
            return t([
                "alarms:SumOfTBelowXWithinYTime"
            ], {
                defaultValue: "SUM(time value < x) > t seconds, within y seconds"
            });
        case generated_graphql_schema__WEBPACK_IMPORTED_MODULE_14__/* .AlarmType.StopForTSeconds */ .$C.StopForTSeconds:
            // Internally t is in seconds, but we display it in minutes - hence "StopForTSeconds" maps to "StopForTMinutes"!
            return t([
                "alarms:StopForTMinutes"
            ], {
                defaultValue: "Stop time > t minutes"
            });
        default:
            return _types_types__WEBPACK_IMPORTED_MODULE_15__/* .assertUnreachable */ .U(type);
    }
};
var formatAlarmTypeInterpolated = function(t, type, config) {
    switch(type){
        case generated_graphql_schema__WEBPACK_IMPORTED_MODULE_14__/* .AlarmType.AboveX */ .$C.AboveX:
            return t([
                "alarms:AboveXInterpolated"
            ], {
                defaultValue: "value > {{x}}",
                x: config.x
            });
        case generated_graphql_schema__WEBPACK_IMPORTED_MODULE_14__/* .AlarmType.BelowX */ .$C.BelowX:
            return t([
                "alarms:BelowXInterpolated"
            ], {
                defaultValue: "value < {{x}}",
                x: config.x
            });
        case generated_graphql_schema__WEBPACK_IMPORTED_MODULE_14__/* .AlarmType.AboveXForTSeconds */ .$C.AboveXForTSeconds:
            return t([
                "alarms:AboveXForTSecondsInterpolated"
            ], {
                defaultValue: "value > {{x}} for {{t}} seconds",
                x: config.x,
                t: config.t
            });
        case generated_graphql_schema__WEBPACK_IMPORTED_MODULE_14__/* .AlarmType.BelowXForTSeconds */ .$C.BelowXForTSeconds:
            return t([
                "alarms:BelowXForTSecondsInterpolated"
            ], {
                defaultValue: "value < {{x}} for {{t}} seconds",
                x: config.x,
                t: config.t
            });
        case generated_graphql_schema__WEBPACK_IMPORTED_MODULE_14__/* .AlarmType.AboveXForTSecondsWithinYTimeNTimes */ .$C.AboveXForTSecondsWithinYTimeNTimes:
            return t([
                "alarms:AboveXForTSecondsWithinYTimeNTimesInterpolated"
            ], {
                defaultValue: "value > {{x}} for {{t}} seconds, {{n}} times, within {{y}} seconds",
                x: config.x,
                t: config.t,
                n: config.n,
                y: config.y
            });
        case generated_graphql_schema__WEBPACK_IMPORTED_MODULE_14__/* .AlarmType.BelowXForTSecondsWithinYTimeNTimes */ .$C.BelowXForTSecondsWithinYTimeNTimes:
            return t([
                "alarms:BelowXForTSecondsWithinYTimeNTimesInterpolated"
            ], {
                defaultValue: "value < {{x}} for {{t}} seconds, {{n}} times, within {{y}} seconds",
                x: config.x,
                t: config.t,
                n: config.n,
                y: config.y
            });
        case generated_graphql_schema__WEBPACK_IMPORTED_MODULE_14__/* .AlarmType.SumOfTAboveXWithinYTime */ .$C.SumOfTAboveXWithinYTime:
            return t([
                "alarms:SumOfTAboveXWithinYTimeInterpolated"
            ], {
                defaultValue: "SUM(time value > {{x}}) > {{t}} seconds, within {{y}} seconds",
                x: config.x,
                t: config.t,
                y: config.y
            });
        case generated_graphql_schema__WEBPACK_IMPORTED_MODULE_14__/* .AlarmType.SumOfTBelowXWithinYTime */ .$C.SumOfTBelowXWithinYTime:
            return t([
                "alarms:SumOfTBelowXWithinYTimeInterpolated"
            ], {
                defaultValue: "SUM(time value < {{x}}) > {{t}} seconds, within {{y}} seconds",
                x: config.x,
                t: config.t,
                y: config.y
            });
        case generated_graphql_schema__WEBPACK_IMPORTED_MODULE_14__/* .AlarmType.StopForTSeconds */ .$C.StopForTSeconds:
            return t([
                "alarms:StopForTSecondsInterpolated"
            ], {
                defaultValue: "stop of type {{stopType}} > {{t}} seconds",
                stopType: config.stopType,
                t: config.t
            });
        default:
            return _types_types__WEBPACK_IMPORTED_MODULE_15__/* .assertUnreachable */ .U(type);
    }
};
var EditButtonProvider = function(props) {
    var formatComponent = function(param) {
        var value = param.value;
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_buttons_edit_button__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z, {
            id: props.id,
            item: null,
            t: props.t,
            onEdit: value
        });
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_devexpress_dx_react_grid__WEBPACK_IMPORTED_MODULE_1__/* .DataTypeProvider */ .zl, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        formatterComponent: formatComponent
    }, props));
};
var ActionsProvider = function(props) {
    var id = props.id, t = props.t, theme = props.theme;
    var formatComponent = function(param) {
        var value = param.value;
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_buttons_edit_button__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z, {
                    id: id,
                    item: null,
                    t: t,
                    onEdit: value.edit,
                    style: {
                        padding: theme.spacing()
                    }
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_buttons__WEBPACK_IMPORTED_MODULE_17__/* .MutationIconButton */ .t, {
                    id: id,
                    tooltipMsg: t([
                        "shared:continue"
                    ], {
                        defaultValue: "Continue"
                    }),
                    onClick: value.continue,
                    color: "primary",
                    style: {
                        padding: theme.spacing()
                    },
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_icons_material_FileCopy__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {})
                })
            ]
        });
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_devexpress_dx_react_grid__WEBPACK_IMPORTED_MODULE_1__/* .DataTypeProvider */ .zl, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        formatterComponent: formatComponent
    }, props));
};


/***/ }),

/***/ 45955:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ formatTargetPerformance; },
/* harmony export */   "t": function() { return /* binding */ formatTargetPerformanceDirect; }
/* harmony export */ });
var formatTargetPerformance = function(t, targetValue, duration) {
    var targetPerformance = targetValue && duration ? (targetValue - duration) / 1000 / 60 : 0;
    return formatTargetPerformanceDirect(t, targetPerformance);
};
var formatTargetPerformanceDirect = function(t, targetPerformance) {
    var targetPerformanceValue;
    if (targetPerformance) {
        // We split the time here in minutes and seconds.
        var minutes = Math.floor(targetPerformance);
        var seconds = Math.floor(targetPerformance % 1 * 60);
        if (targetPerformance > 0) {
            targetPerformanceValue = seconds > 0 ? t([
                "shared:nInMinutesAndSecAhead"
            ], {
                defaultValue: "{{minutes}}min {{seconds}}sec ahead",
                minutes: minutes,
                seconds: seconds
            }) : t([
                "shared:nInMinutesAhead"
            ], {
                defaultValue: "{{minutes}}min ahead",
                minutes: minutes
            });
        } else if (targetPerformance < 0) {
            targetPerformanceValue = seconds > 0 ? t([
                "shared:nInMinutesAndSecBehind"
            ], {
                defaultValue: "{{minutes}}min {{seconds}}sec behind",
                minutes: minutes,
                seconds: seconds
            }) : t([
                "shared:nInMinutesBehind"
            ], {
                defaultValue: "{{minutes}}min behind",
                minutes: minutes
            });
        } else {
            targetPerformanceValue = t([
                "device:exactlyOnTarget"
            ], {
                defaultValue: "Exactly on target"
            });
        }
    }
    return targetPerformanceValue;
};


/***/ }),

/***/ 99591:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "R": function() { return /* binding */ stopTypeNames; }
/* harmony export */ });
var stopTypeNames = function(t) {
    return {
        DOWNTIME: t([
            "stop:lossDuringOperation"
        ], {
            defaultValue: "Loss During Operation"
        }),
        NO_ACT: t([
            "stop:noActivityAtLine"
        ], {
            defaultValue: "No Activity at Line"
        }),
        NON_PROD: t([
            "stop:nonProductionActivities"
        ], {
            defaultValue: "Non-production Activities"
        }),
        BATCH_NON_PROD: t([
            "stop:batchSpecificNonOperation"
        ], {
            defaultValue: "Batch-specific Non-operation"
        }),
        UNREGISTERED: t([
            "shared:unregistered"
        ], {
            defaultValue: "Unregistered"
        }),
        MICRO_STOP: t([
            "shared:microStop"
        ], {
            defaultValue: "Micro stop"
        })
    };
};


/***/ })

}]);